import * as constants from './Forget.constants';
import * as services from './Forget.service';

const state = {
  message: '',
  isRequest: false,
};

const mutations = {
  [constants.PASSWORD_FORGET_DONE](state, message) {
    state.message = message;
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async passwordForget({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const params = services.passwordForget(payload);
    const res = await params;
    commit(constants.PASSWORD_FORGET_DONE, res.data.message);
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return params;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
